import { Postulacion } from '../../../../core/models/postulaciones.models';
import { avanceVisiblePostulacion, folioVisiblePostulacion } from '../../../../core/utils/postulaciones-filter.util';

export function construirCsvPostulaciones(
  postulaciones: Postulacion[],
  esRolInstitucional: boolean,
  obtenerIdProyecto: (item: Postulacion) => string,
  obtenerEstado: (item: Postulacion) => string
): string {
  const headers = esRolInstitucional
    ? ['ID Postulación', 'Concurso', 'ID Proyecto', 'Subdirección', 'Folio', 'Proyecto', 'Avance', 'Estado', 'Fecha inicio', 'Fecha término']
    : ['Convocatoria', 'Línea', 'ID Postulación', 'Folio', 'Avance', 'Fecha de cierre', 'Estado'];

  const rows = postulaciones.map((item) =>
    esRolInstitucional
      ? [
          item.idPostulacion,
          item.concurso,
          obtenerIdProyecto(item),
          item.subdireccion,
          folioVisiblePostulacion(item),
          item.nombreProyecto,
          `${avanceVisiblePostulacion(item)}%`,
          obtenerEstado(item),
          item.fechaInicio,
          item.fechaTermino,
        ]
      : [
          item.concurso,
          item.subdireccion,
          item.idPostulacion,
          folioVisiblePostulacion(item),
          `${avanceVisiblePostulacion(item)}%`,
          item.fechaTermino,
          obtenerEstado(item),
        ]
  );

  return [headers, ...rows]
    .map((line) => line.map((cell) => `"${String(cell).replaceAll('"', '""')}"`).join(','))
    .join('\n');
}

export function construirNombreDescargaPostulaciones(fechaIso: string): string {
  return `postulaciones-filtradas-${fechaIso}.csv`;
}
